import request from '@/utils/request'

// 获取新闻类型
export function getArticle (data) {
  return request({
    url: '/ArticleApi/ArticleTypeIndex',
    method: 'post',
    data
  })
}
// 获取新闻中心
export function getArticleApiIndex (data) {
  return request({
    url: '/ArticleApi/Index',
    method: 'post',
    data
  })
}
// 获取新闻详情
export function getArticleApiShow (data) {
  return request({
    url: '/ArticleApi/Show',
    method: 'post',
    data
  })
}
// 获取首页中新闻
export function getArticleApiHome (data) {
  return request({
    url: '/ArticleApi/ArticleIndex',
    method: 'post',
    data
  })
}
